import React, { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import { AstraModemSubscriptionDataList, AstraModemSubscriptionListSchema } from "./api/AstraSubscription";
import { APIRequestGet } from "../../utils/APIRequests";

/** При входе в консоль предупреждает о подписках, которые заканчиваются или уже закончились. */
const SubscriptionNotification: React.FC = () => {
    const daysLeftForWarning = 10;

    const [subscriptionEnding, setSubscriptionEnding] = useState<AstraModemSubscriptionDataList>();
    const [subscriptionExpire, setSubscriptionExpire] = useState<AstraModemSubscriptionDataList>();
    const [showWarning, setShowWarning] = useState(false);

    useEffect(() => {
        APIRequestGet(`/astraSubscription/getSubscriptions`, {
            schema: AstraModemSubscriptionListSchema,
            logSuccess: true
        }).then((result) => {
            const ending = result.data.filter(x => x.daysLeft < daysLeftForWarning && x.daysLeft > 0);
            const expire = result.data.filter(x => x.daysLeft <= 0);
            setSubscriptionEnding(ending)
            setSubscriptionExpire(expire)
            if (ending.length > 0 || expire.length > 0) {
                setShowWarning(true);
            }
        });
    }, []);

    return (
        <>
            <Modal show={showWarning} onHide={() => { setShowWarning(false) }}>
                <Modal.Header closeButton>
                    <Modal.Title style={{ color: "black" }}>Внимание</Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ color: "black" }}>
                    {(subscriptionEnding && subscriptionEnding?.length > 0) &&
                        <div>
                            Действие {subscriptionEnding?.length === 1 ? "подписки" : "подписок"}
                            {subscriptionEnding?.map(x => (<> {x.modemName} {' (' + x.daysLeft.toFixed() + " дней)"} </>))}
                            заканчивается
                        </div>
                    }
                    {(subscriptionExpire && subscriptionExpire?.length > 0) &&
                        <div>
                            {subscriptionExpire?.length === 1 ? "Закончилась подписка" : "Закончились подписки"}
                            {subscriptionExpire?.map(x => (<> {x.modemName} </>))}
                        </div>
                    }
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={() => { window.location.href = "/subscriptions" }}>
                        Управление подписками
                    </Button>
                    <Button variant="secondary" onClick={() => { setShowWarning(false) }}>
                        Закрыть
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default SubscriptionNotification;